import { PORTAL_BASE_URL } from "../env";

const UTM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_term",
    "utm_content",
];

const safeGetUrlParams = () => {
    if (typeof window === "undefined") return new URLSearchParams();
    try {
        return new URLSearchParams(window.location.search);
    } catch (e) {
        return new URLSearchParams();
    }
};

const safeLocalGet = (key) => {
    if (typeof window === "undefined") return null;
    try {
        return window.localStorage.getItem(key);
    } catch (e) {
        return null;
    }
};

export const getUtmParams = () => {
    const urlParams = safeGetUrlParams();
    const utms = {};
    UTM_KEYS.forEach((key) => {
        const value = urlParams.get(key) || safeLocalGet(key);
        if (value) utms[key] = value;
    });
    if (!utms.utm_source) utms.utm_source = "direct";
    return utms;
};

const appendParamsToPath = (path, params) => {
    if (!path) return "";
    const [base, existingQuery = ""] = path.split("?");
    const search = new URLSearchParams(existingQuery);
    Object.entries(params).forEach(([key, value]) => {
        if (!search.has(key)) search.set(key, value);
    });
    const queryString = search.toString();
    return queryString ? `${base}?${queryString}` : base;
};

export const buildRegisterUrl = (redirectPath = "") => {
    const utms = getUtmParams();
    const topLevel = new URLSearchParams();

    if (redirectPath) {
        topLevel.set("redirectURL", appendParamsToPath(redirectPath, utms));
    }
    Object.entries(utms).forEach(([key, value]) => topLevel.set(key, value));

    return `${PORTAL_BASE_URL}/register?${topLevel.toString()}`;
};

export const redirectToRegister = (redirectPath = "", { newTab = false } = {}) => {
    const url = buildRegisterUrl(redirectPath);
    if (newTab && typeof window !== "undefined") {
        window.open(url, "_blank");
    } else if (typeof window !== "undefined") {
        window.location.href = url;
    }
    return url;
};
